import { useCallback, useMemo, useState } from "react";

import { PlanStockDiffStore } from "./plan-stock-diff-store";
import { useUpdatePlanStock } from "../../repository/mutation/use-update-plan-stock";

import type { ServerModel } from "./type";

type Props = {
	serverModel: ServerModel;
};

export const useCreatePlanStockFormModel = ({ serverModel }: Props) => {
	const [isValid, setIsValid] = useState(false);
	const [isDirty, setIsDirty] = useState(false);

	const planStockDiffStore = useMemo(
		() => new PlanStockDiffStore(serverModel.planStock.items, setIsValid, setIsDirty),
		[serverModel.planStock.items],
	);

	const onReInitialize = useCallback(() => {
		setIsValid(false);
		setIsDirty(false);
		planStockDiffStore.clear();
	}, [planStockDiffStore]);

	const { onUpdatePlanStock } = useUpdatePlanStock({
		onReInitialize,
		serverModel,
		planStockDiffStore,
	});

	return {
		isDirty,
		isValid,
		onUpdatePlanStock,
		onReInitialize,
		planStockDiffStore,
	};
};
